<template>
	<div class="flex xs-column xs-12 p4">
		<label class="fs3 fw5 mb1 c6">{{ $t("to") }}</label>
		<div class="flex xs-bottom xs-12 mb4">
			<j-base-select
				size="small"
				class="xs mr2"
				:options="listOfUsers"
				v-model="form.to"
			/>
			<j-button
				size="xsmall"
				type="bordered"
				class="mr2"
				@click="displayCCInput = !displayCCInput"
				>{{ $t("cc") }}</j-button
			>
			<j-button
				size="xsmall"
				type="bordered"
				@click="displayBCCInput = !displayBCCInput"
				>{{ $t("bcc") }}</j-button
			>
		</div>

		<label v-if="displayCCInput" class="fs3 fw5 mb1 c6">{{ $t("cc") }}</label>
		<div v-if="displayCCInput" class="flex xs-middle xs-12 mb4">
			<j-base-multi-select
				size="small"
				class="xs mr2"
				:options="listOfUsers"
				v-model="form.ccs"
				:allowLocalSearch="true"
			/>
		</div>

		<label v-if="displayBCCInput" class="fs3 fw5 mb1 c6">{{ $t("bcc") }}</label>
		<div v-if="displayBCCInput" class="flex xs-middle xs-12 mb4">
			<j-base-multi-select
				size="small"
				class="xs mr2"
				:options="listOfUsers"
				v-model="form.bccs"
				:allowLocalSearch="true"
			/>
		</div>

		<label class="fs3 fw5 mb1 c6">{{ $t("subject") }}</label>
		<div class="flex xs-middle xs-12 mb4">
			<j-base-input-text class="xs" v-model="form.subject" size="small" />
		</div>

		<core-rich-text-editor
			class="mb4"
			:hasMenuBar="false"
			:toolbarConfig="toolbarConfig"
			v-model="form.htmlContent"
		/>

		<div class="flex xs-12 xs-right">
			<j-button @click="sendNotification" :isLoading="isLoading">{{
				$t("send")
			}}</j-button>
		</div>
	</div>
</template>

<script>
import JBaseInputText from "@/components/JBaseInputText/"
import JBaseSelect from "@/components/JBaseSelect/"
import JBaseMultiSelect from "@/components/JBaseMultiSelect/"
import JButton from "@/components/JButton/"

import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	name: "CoreSendEmailNotification",

	components: {
		JBaseInputText,
		JBaseSelect,
		JBaseMultiSelect,
		JButton,
		CoreRichTextEditor: () =>
			import("@/modules/core/components/CoreRichTextEditor/")
	},

	data() {
		return {
			displayCCInput: false,
			displayBCCInput: false,
			form: {
				to: null,
				ccs: null,
				bccs: null,
				subject: null,
				htmlContent: null
			},

			toolbarConfig: [
				"bold",
				"italic",
				"alignleft",
				"aligncenter",
				"alignright",
				"alignjustify",
				"link",
				"image",
				"numlist",
				"bullist",
				"pagebreak",
				"hr"
			],

			listOfUsers: [],

			isLoading: false
		}
	},

	methods: {
		async fetchUsers() {
			const query = gql`
				query fetchUsers {
					logins {
						list {
							associatedUser {
								name
							}
							email
						}
					}
				}
			`

			const res = await api({ query, variables: {} })

			this.listOfUsers = res?.data?.logins?.list?.map(item => ({
				name: `${item?.associatedUser?.name} - ${item?.email}`,
				value: item?.email
			}))
		},

		async sendNotification() {
			const query = gql`
				mutation sendNotification($input: sendNotificationInput!) {
					sendNotification(input: $input) {
						status
						errors
					}
				}
			`

			const variables = {
				input: {
					emailMessage: {
						...this.form,
						from: this.$store.state.email
					}
				}
			}

			this.isLoading = true
			const res = await api({ query, variables })
			this.isLoading = false

			if (res?.data?.sendNotification?.status !== "success") {
				this.$store.dispatch(
					"showError",
					res?.data?.sendNotification?.errors?.[0] || this.$t("errors.general")
				)
			}

			this.$emit("notification:sent")
		}
	},

	created() {
		this.fetchUsers()
	}
}
</script>
